import React from 'react'
import lostandfound from "../src/images/lnf.webp";
import authorizationletter from '../src/images/authorizationformat.pdf'
import {Helmet} from 'react-helmet-async';

const Lostandfound = () => {
  return (
    <>
    <Helmet>
      <title>Lost and Found Page</title>
      <meta name='description' content="Find out information regarding Lost and Found (L&F) at Coimbatore International Airport."/>
      <link rel="canonical" href="/lostandfound"/>
    </Helmet>
    <section id="header">
        <div className="container-fluid nav_bg">
          <div className="row">
            <div className="col-12 mx-auto">
              <div className="row">
                <div className="col-lg-6 order-1 order-lg-2 header-img">
                  <img
                    src={lostandfound}
                    className="img-fluid animated"
                    alt="Lost and Found"
                  />
                </div>
                <div className="col-md-6 pt-3 pt-lg-0 order-2 order-lg-1">
                  <h3>
                    <strong className='fs-1 text'>Lost & Found Items</strong>
                  </h3>
                  <h5 className="my-3">
                  Contact Duty Terminal Manager on <br/><a href="tel:+4222591905">0422-2591905</a> / <a href="tel:+9442191902">9442191902</a>


<br/><br/><br/><strong className='fs-2 text'>Procedure to claim lost property
</strong><br/>
There are 2 ways to claim your item:-<br/>
1. Claim yourself<br/>
2. Authorize someone to claim

<br/><br/><br/><strong className='fs-2 text'>Documents Required(if claiming yourself)</strong><br/>
The item may be claimed by the owner and should be in the possession of the following documents:<br/>
1. Copy of Boarding pass /proof of journey<br/>
2. Copy of passport/ID card issued by any govt. unit.
<br/><br/><strong className='fs-2 text'>Documents Required(if authorizing someone to claim your items)</strong><br/>

1. Letter of authorisation to collect item on behalf of owner.<br/><a href={authorizationletter} download='Authorizationletter'>Click to download Authorization Letter Format</a><br/>
2. Copy of Boarding pass.<br/>
3. Owner’s Govt. authorised photo ID card preferably AADHAR card/Licence/PAN card.<br/>
4. Photo ID card of the person authorised to collect.

<br/><br/><strong className='fs-2 text'>Important Note</strong><br/>
Item must be collected within 90 days from the date of receipt of item.<br/><br/> On expiry of 90 days it will be disposed of as per GOVT. directives/guidelines.<br/><br/> AAI will not be liable for any type of further claim.<br/><br/>

Perishable items are kept for 48 hours after which they will be disposed of.<br/><br/> The lost property is kept on as is where is basis.<br/><br/> AAI is not liable for any damages to any lost property under its custody.

<br/><br/><strong className='fs-2 text'>Collection of Lost items</strong><br/>

For collection of lost items kindly contact the Airport Manager office on <br/> <a href="tel:+4222591905">0422-2591905</a> / <a href="tel:+9442191902">9442191902</a>
                  </h5>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>
    </>
  )
}

export default Lostandfound